import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Stack, Typography } from '@mui/material'

const WidgetHeader = ({ title, format, styles, t_ }) => {
  return (
    <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ px: 0, pt: 0, pb: 1 }}>
      <Stack spacing={0.5}>
        <Typography sx={{ ...styles.subtitle2, fontWeight: 700, fontSize: '0.95rem' }}>
          {title}
        </Typography>
        <Typography variant='caption' sx={{ color: 'text.secondary', fontWeight: 500, opacity: 0.8 }}>
          {format === '12h'
            ? (t_ ? t_('12h Scale') : '12h Scale')
            : (t_ ? t_('24h Scale') : '24h Scale')}
        </Typography>
      </Stack>
    </Stack>
  )
}

WidgetHeader.propTypes = {
  title: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
  t_: PropTypes.func
}

export default memo(WidgetHeader)
